import {SET_ROUTE_LIST,} from '../actionTypes'

const getDefaultState = () => {
    let routeList = JSON.parse(localStorage.getItem('routeList'))
    if (!routeList) {
        routeList = []
    }
    return {
        routeList: routeList
    }
}
export default function (state = getDefaultState(), action) {

    // Logout
    if (action.type === SET_ROUTE_LIST) {
        let routeList = action.payload
        localStorage.setItem('routeList', JSON.stringify(routeList))
        return {
            routeList: routeList
        }
    }

    return state
}
